import React from "react";
import { Scale } from "lucide-react";
import { StaticPage, Block } from "../components/StaticPage";

const LegalPage = () => (
  <StaticPage icon={Scale} title="Mentions légales" testid="legal-page"
    intro="Informations légales relatives au site KTSauto.">
    <Block title="Éditeur du site">
      <p>KTSauto SAS — Capital social : 50 000 €<br />
      RCS Tours 900 123 456 — SIRET 900 123 456 00012<br />
      N° TVA intracommunautaire : FR12 900123456</p>
    </Block>
    <Block title="Contact">
      <p>Email : contact@ktsauto.fr</p>
    </Block>
    <Block title="Directeur de la publication">
      <p>Le représentant légal de KTSauto SAS.</p>
    </Block>
    <Block title="Hébergement">
      <p>Le site est hébergé par un prestataire d'infrastructure cloud assurant la disponibilité et la sécurité
      des services.</p>
    </Block>
    <Block title="Propriété intellectuelle">
      <p>L'ensemble des contenus du site (textes, visuels, logos, marques) est protégé. Toute reproduction sans
      autorisation est interdite.</p>
    </Block>
    <Block title="Données personnelles">
      <p>Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données.
      Pour l'exercer, écrivez-nous à contact@ktsauto.fr.</p>
    </Block>
  </StaticPage>
);

export default LegalPage;
